import { usePlanificaciones } from '../providers/PlanificacionesProvider'
import DashboardView from './dashboard/DashboardView'
import DetailView from './DetailView'

export default function PlanificacionesContainer() {
  const { currentView } = usePlanificaciones()

  return currentView === 'dashboard' ? (
    <DashboardView />
  ) : currentView === 'form' || currentView === 'gantt' ? (
    <DetailView />
  ) : null
}
